import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import { ButtonGroup } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { LinkButton, AddButton } from 'components/ui';
import { productWarehouseService } from 'features/inventory/warehouses/api/product-warehouse.service';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { examService, examTagService } from 'shared/services';
import { Option } from 'shared/types/general';
import { ExamsColumns } from '../exams';

export const Exams = () => {
  const translationPrefix = 'pages.exams.list';
  const { t } = useTranslation();
  const [tagOptions, setTagOptions] = useState<string[]>([]);

  useEffect(() => {
    examTagService
      .getAllBaseInformation()
      .then((tags: Option[]) => {
        if (tags && Array.isArray(tags)) {
          setTagOptions(tags.map((tag) => tag.code));
        } else {
          setTagOptions([]);
        }
      })
      .catch(() => {
        setTagOptions([]);
      });
  }, []);

  const columns: GridColDef[] = ExamsColumns(
    productWarehouseService,
    undefined,
    undefined,
    tagOptions
  );

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <ButtonGroup>
          <LinkButton
            to="/tenant/cost-analysis/macro-exams"
            requirePermission={'superAdmin'}
            label={t(`menu.macro-exams`)}
            icon={BloodtypeIcon}
          />
          <AddButton to="new" prefix={translationPrefix} />
        </ButtonGroup>
      }>
      <EnhancedDataGrid columns={columns} service={examService} disableExport={true} />
    </TenantPage>
  );
};

export default Exams;
